import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import authRoutes from './authRoutes'
import userRoutes from './userRoutes'
import productRoutes from './productRoutes'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};


const routes = [
  {
    path: '/',
    name: 'HomeDestaques',
    component: () => import('@/views/HomeDestaques.vue'),
    meta: { public: true }
  },
  ...authRoutes,
  ...userRoutes,
  ...productRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Guard global de rota
router.beforeEach((to, from, next) => {
  const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado') || 'null')
  const isAuthenticated = !!usuarioLogado?.id

  const onlyGuest = to.matched.some(record => record.meta.onlyGuest)
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isPublic = to.matched.some(record => record.meta.public)

  // Bloqueia se for rota para "guest" e usuário estiver logado
  if (onlyGuest && isAuthenticated) {
    return next({ name: 'HomeDestaques' })
  }

  // Bloqueia se for rota protegida e o usuário não estiver logado
  if (requiresAuth && !isAuthenticated) {
    console.log('login');
    return next({ name: 'LoginUsuario', query: { redirect: to.fullPath } })
  }

  // Caso contrário, segue normalmente
  return next()
})

export default router
